




















































































































import {Component, Vue} from "vue-property-decorator";
import YcHeader from "@/components/common/yc-header.vue"
import YcAside from "@/components/common/yc-aside.vue"
import {getSubscriptionPlanList, getSubscriptionPlan} from "@/services/api";
import Content from '../components/home/content.vue'
import crown1 from '../assets/img/common/crown_1.svg'
import crown2 from '../assets/img/common/crown_2.svg'
import crown3 from '../assets/img/common/crown_3.svg'
import planBg1 from '../assets/img/common/package_bg_1.png'
import planBg2 from '../assets/img/common/package_bg_2.png'
import planBg3 from '../assets/img/common/package_bg_3.png'
import {Plan, SubscriptionPlanData, SubscriptionPlanResp} from "@/model/Subscription";


@Component({
  components: {
    'yc-aside': YcAside,
    'zf-content': Content,
    'yc-header': YcHeader
  },
})
export default class SubscriptionPlan extends Vue {

  public planMap = {
    Standard: {
      color: '#6A79DD',
      crown: crown1,
      planBg: planBg1
    },
    Advanced: {
      color: '#BE7945',
      crown: crown2,
      planBg: planBg2
    },
    Channel: {
      color: '#513EFF',
      crown: crown3,
      planBg: planBg3
    }
  }

  public SubscriptionPlanData: SubscriptionPlanData = {
    userInfo: {
      totalContactCount: 0
    },
    subscriptionPlans:[]
  }

  created(): void {
    getSubscriptionPlanList({}, true).then(res => {
      this.SubscriptionPlanData = res.data.data;
    })
  }

  /**
   * 订阅
   * @param plan
   */
  public dialogVisible = false;
  public activePlan: SubscriptionPlanResp|{} = {};
  subscribe(plan: Plan) {
    getSubscriptionPlan({
      planLevelName: plan.planLevelName,
      price: plan.price,
      integrationId: 1
    }, true).then(res => {
      switch (res.data.data.status) {
        case 1:
          res.data.data.confirmationUrl && (location.href = res.data.data.confirmationUrl);
          break;
        case 2: case 3: case 4: case 5: default:
          this.activePlan = {...res.data.data, plan};
          this.dialogVisible = true;
          break;
      }
    })
  }


}
